type AuthConsentCheckboxProps = {
  checked: boolean
  description: React.ReactNode
  id: string
  onChange: (checked: boolean) => void
}

export function AuthConsentCheckbox({
  checked,
  description,
  id,
  onChange,
}: AuthConsentCheckboxProps) {
  return (
    <label className="grid cursor-pointer grid-cols-[1.25rem_1fr] items-start gap-3 text-text-primary" htmlFor={id}>
      <input
        checked={checked}
        className="peer absolute opacity-0 pointer-events-none"
        id={id}
        onChange={(event) => onChange(event.target.checked)}
        type="checkbox"
      />
      <span
        aria-hidden="true"
        className={[
          'relative inline-flex h-5 w-5 items-center justify-center rounded-full border bg-surface-card',
          'transition-[border-color,background-color,box-shadow] duration-150 peer-focus-visible:ring-4 peer-focus-visible:ring-focus-ring',
          checked ? 'border-brand-primary' : 'border-border-soft',
        ].join(' ')}
      >
        <span
          className={[
            'h-[0.55rem] w-[0.55rem] rounded-full transition-colors duration-150',
            checked ? 'bg-brand-primary' : 'bg-transparent',
          ].join(' ')}
        />
      </span>
      <span className="text-body-2 leading-[1.6] text-balance [&_a]:text-inherit">{description}</span>
    </label>
  )
}
